































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { UserService } from '../services/admin/user.service';
import { AccountService } from '../services/admin/account.service';
import { CookieHelper } from '../helper/cookie.helper';
import { Base } from '../components/common/base';
import { EnvironmentName } from '@/helper/enum';
import { Utils } from '@/helper/utils';

@Component({})
export default class NoSidebarLayout extends Base {
  public userService: UserService;
  public accountService: AccountService;
  public userName: string = '';
  public footer:string;

  public created(): void {
    this.footer = Utils.AppEnvironmentTitle;
    
    this.userName = this.userSession.displayname;
  }
  public async mounted(): Promise<void> {
    this.userService = new UserService();
    this.accountService = new AccountService();
    if (!this.userName) {
      await this.getCurrentUserInfo();
    }
  }

  public async getCurrentUserInfo(): Promise<void> {
    const user = await this.userService.getCurrentUserInfoAsync();
    this.$store.dispatch('setUserDisplayName', user.displayName);
    this.$store.dispatch('setUserEmail', user.email);
    this.$store.dispatch('setUserId', user.userId);
    this.userName = user.displayName;
  }

  public setIsStore() {
    this.$store.dispatch('setIsStoreSelected', true);
    this.$router.push({ name: 'app.account.profile' });
  }

  public logOff(): void {
    this.accountService.logout(this);
    CookieHelper.setCookie('loggedInUserEmail', '');
    // location.href = '/app/account/Login';
  }
}
